import request from '@/utils/request'

export function login (data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}


export function login_with_google (data) {
  return request({
    url: '/auth/loginWithGoogleToken',
    method: 'post',
    data
  })
}

export function login_with_keycloak (data) {
  return request({
    url: '/auth/loginWithKeycloakToken',
    method: 'post',
    data
  })
}

export function getInfo () {
  const ret = request({
    url: '/auth/check',
    method: 'get'
  })
  ret.catch(() => console.error('User not logged'))
  return ret
}

export function logout () {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

export function forgotPass (data) {
  return request({
    url: '/auth/forgotPass',
    method: 'post',
    data
  })
}

export function confirmForgotPass (data) {
  return request({
    url: '/auth/confirmForgotPass',
    method: 'post',
    data
  })
}

export function changePass (data) {
  return request({
    url: '/auth/changePass',
    method: 'post',
    data
  })
}

export function getConfig() {
  const ret = request({
    url: '/config',
    method: 'get'
  })
  return ret  
}